module.exports = __webpack_public_path__ + "static/media/confirm_relabel.a2ffc380.svg";